import React from "react";
import "../styles/Content.css";
import ContentImage from "../assets/content.png";

function Content() {
  return (
    <div className="container">
      <div className="row">
        <div className="column12 left">
          <img src={ContentImage} alt="Left Column" className="main-image" />
        </div>
        <div className="column12 right">
          <h2 className="section-heading">
            Explore the world's <span className="highlight">Imagination</span>
          </h2>
          <p>
            Our AI image generator brings imagination to life, producing
            stunning art, illustrations, and photos in seconds. Unleash
            creativity and express yourself in new ways with the power of AI.
            Explore endless possibilities, from crafting unique marketing
            materials to creating beautiful artwork, all with supreme ease and
            efficiency.
          </p>
        </div>
      </div>
    </div>
  );
}

export default Content;
